import React from 'react';

const NotFound = () => {
	return <>존재하지 않는 페이지입니다.</>;
};

export default NotFound;
